import * as React from 'react';

import CollectionStar16 from './CollectionStar16';

export const collectionStar16 = () => <CollectionStar16 />;

export default {
    title: 'Icon/Line/CollectionStar16',
    component: CollectionStar16,
    parameters: {
        notes: "`import CollectionStar16 from 'box-ui-elements/es/icon/line/CollectionStar16';`",
    },
};
